module.exports = __webpack_public_path__ + "img/contact-thaw.484e0056.jpg";